import React from 'react';
import Router from './Router';

const News = () => {
  return (
    <div className="container-fluid">
      <Router />
    </div>
  );
};

export default News;
